import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PAGE_NAME } from "../../../const/analytics";
import endPoints from "../../../const/endpoints";
import icons from "../../../const/icons";
import { useAccountSummary } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import { useConfig } from "../../../hooks/useConfig";
import MessageBox from "../../atoms/MessageBox";
var EnrollmentPageError = function () {
    var _a;
    var assets = useConfig().hosts.assets;
    var accountId = useStatementsContext().state.accountId;
    var accountSummary = useAccountSummary(accountId).data;
    var t = useTranslation().t;
    var enrollErrorIcon = "".concat(assets).concat(endPoints.digitalAssets).concat(icons.errorIcon);
    var isAccountDelinquent = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.conditions.includes("DELINQUENT");
    var messageDescription = isAccountDelinquent
        ? "modal.enroll.delinquent"
        : "modal.enroll.error.description";
    var enrollmentUnavailableText = "enrollment unavailable";
    useEffect(function () {
        var _a, _b, _c, _d;
        if (!isAccountDelinquent) {
            triggerAnalytics({
                pageName: PAGE_NAME.API_FAILED,
                pageSubFunction: enrollmentUnavailableText,
                errorMessage: t("modal.enroll.error.title", { lng: "en" }),
                message: t("modal.enroll.error.description", { lng: "en" }),
                messageType: enrollmentUnavailableText,
                clientName: (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId,
                product: (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type,
            });
        }
        if (isAccountDelinquent) {
            triggerAnalytics({
                pageName: PAGE_NAME.DELINQUENT_STATUS,
                pageSubFunction: enrollmentUnavailableText,
                errorMessage: t("modal.enroll.delinquent", { lng: "en" }),
                message: enrollmentUnavailableText,
                messageType: enrollmentUnavailableText,
                clientName: (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _c === void 0 ? void 0 : _c.clientId,
                product: (_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.type,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId, isAccountDelinquent]);
    return (_jsx(MessageBox, { color: "#fcf4f3", type: "error", icon: _jsx("img", { src: enrollErrorIcon, width: "24px", height: "24px", alt: "enrollment-error-icon" }), title: !isAccountDelinquent ? "modal.enroll.error.title" : undefined, description: messageDescription }));
};
export default EnrollmentPageError;
